import styled from '@emotion/styled';
import { Typography } from '../../components/Typography/Typography';
import { Button, useTheme } from '@mui/material';
import { text } from '../../themes/text';

const Wrapper = styled('div')`
  padding: 34px 62px;
`;

const Content = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const MainSection = styled('div')`
  height: 256px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 146px;
`;

export const DeactivatedUser = () => {
  const { colors } = useTheme();
  return (
    <Wrapper>
      <Content>
        <MainSection>
          <Typography
            variant='h1'
            style={{ fontSize: `${text.size.extraExtraLarge}px` }}
            color={colors.text.main}
          >
            Account Deactivated
          </Typography>
          <Typography
            variant='h3'
            style={{ marginTop: '22px', fontFamily: text.font.salvaTest }}
            color={colors.text.main}
          >
            Your account has been deactivated.
          </Typography>
          <Typography
            variant='h3'
            color={colors.text.main}
            style={{ marginBottom: '34px', fontFamily: text.font.salvaTest }}
          >
            To resolve access issues, please contact our support team.
          </Typography>
          <Button variant='contained' style={{ height: '40px' }}>
            <Typography
              variant='h4'
              color={colors.textAccent.inverse}
              style={{ marginBottom: '-1px' }}
            >
              Contact Support
            </Typography>
          </Button>
        </MainSection>
      </Content>
    </Wrapper>
  );
};
